import React, { useState, useContext } from 'react'
import FirebaseContext from '../../firebase/context'

function ForgotPassword() {
	const { firebase } = useContext(FirebaseContext)
	const [resetPasswordEmail, setResetPasswordEmail] = useState('')
	const [isPasswordReset, setIsPasswordReset] = useState(false)
	const [passwordResetError, setPasswordResetError] = useState(null)

	async function handleResetPassword() {
		try {
			await firebase.resetPassword(resetPasswordEmail)
			setIsPasswordReset(true)
			setPasswordResetError(null)
		} catch (error) {
			console.error('Error sending email', error)
			setPasswordResetError(error.message)
			setIsPasswordReset(false)
		}
	}

	return (
		<div>
			<input onChange={e => setResetPasswordEmail(e.target.value)} type='email' className='input' placeholder='Provide your email' />
			<div>
				<button onClick={handleResetPassword} className='button'>
					Reset Password
				</button>
			</div>
			<div className=''>
				{isPasswordReset && <p>Check email to reset password</p>}
				{passwordResetError && <p className='error-text'>{passwordResetError}</p>}
			</div>
		</div>
	)
}

export default ForgotPassword
